import TemplateView from '../../../TemplateView'
import * as UserNameFormat from '../../../util/UserNameFormat'

export default class AssignedTeamRow extends TemplateView {
    constructor({
        firstName = '',
        lastName = '',
        middleInitial = '',

    }) {
        super()
        this.params = {
            firstName,
            lastName,
            middleInitial,
        }
    }

    templateHtml() {
        return "<div class='teamRow'><%-rowText%></div>"
    }

    templateModel() {
        return {
            rowText: UserNameFormat.formatLFM(this.params.firstName, this.params.lastName, this.params.middleInitial),
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/components/AssignedTeamRow.js